import React from 'react';
import {
  Document,
  Page,
  pdfjs,
} from 'react-pdf';
import pdfFile from '../../../assets/pdfs/Apple_SSO_FAQ.pdf';
import {useSelector} from 'react-redux';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`; 

const AppleRequirements = () => {

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  const height = windowHeight - 64;

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (
      <div style={{
        justifyContent: 'center',
        alignContent: 'center',
        padding: 10,
        width: width,
        height: height,}}>
        <Document file={pdfFile}>
          <Page pageNumber={1} renderTextLayer={false} renderAnnotationLayer={false} width={width - 20} scale={1} />
        </Document>
      </div>
  );
}

export default AppleRequirements;
